module.exports = __webpack_public_path__ + "static/media/plico1.36ee8780.jpg";